import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	helpCenterLozenge: {
		id: 'servicedesk.channels-jsd.channels.help-center.jsm-custom-domain-lozenge.help-center-lozenge',
		defaultMessage: 'UPDATED',
		description: 'Lozenge status from a custom domain being changed in the help center',
	},
});
